import request from "@/utils/oms-request";
import lms_request from "@/utils/request";
import omsRequest from "@/utils/oms-request";
// import download from "@/utils/oms-download";

// 查询平仓处理人设置
export const getClosureOrderSetting = () =>
  lms_request({
    url: "/closure-order-setting",
    method: "get",
  });
// 修改平仓处理人设置
export const putClosureOrderSetting = (data) =>
  lms_request({
    url: "/closure-order-setting",
    method: "put",
    data,
  });
// 查询平仓单列表
export const getclosureOrder = (params) =>
  lms_request({
    url: "/closure-order",
    method: "get",
    params,
  });
export const getclosureOrderApprove = (params) =>
  lms_request({
    url: "/closure-order/approve",
    method: "get",
    params,
  });
// 作废平仓单
export const invalidClosureOrder = (data) =>
  lms_request({
    url: "/closure-order/invalid",
    method: "post",
    data,
  });
// 撤回平仓单
export const revertClosureOrder = (id) =>
  lms_request({
    url: `/closure-order/revert/${id}`,
    method: "post",
  });
// 获取平仓类型
export const getClosureType = () =>
  lms_request({
    url: `/closure-order/type`,
    method: "get",
  });
// 获取关联单据类型
export const getClosureOrderType = () =>
  lms_request({
    url: `/closure-order/order-type`,
    method: "get",
  });
// 创建平仓单（数据回退）
export const postClosureOrder = (data) =>
  lms_request({
    url: "/closure-order",
    method: "post",
    data,
  });
// 审核平仓单
export const postApprove = (data) =>
  lms_request({
    url: "/closure-order/approve",
    method: "post",
    data,
  });
// 查询关联单据ID
export const getRelateOrderId = (params) =>
  lms_request({
    url: `/closure-order/relate-order`,
    method: "get",
    params,
  });
// 获取平仓注意事项
export const getNotion = (params) =>
  lms_request({
    url: `/closure-order-setting/notion`,
    method: "get",
    params,
  });
// 查询平仓单详情
export const getClosingOrderInfo = (id) =>
  lms_request({
    url: `/closure-order/${id}`,
    method: "get",
  });
// 校验平仓单
export const closingOrderCheck = (id) =>
  lms_request({
    url: `/closure-order/check/${id}`,
    method: "post",
  });
// 提交审核平仓单
export const closingOrderCheckSubmit = (data) =>
  lms_request({
    url: `/closure-order/submit`,
    method: "post",
    data,
  });
// 实时查询关联单据状态
export const getStateSollbackStatus = (params) =>
  lms_request({
    url: `/closure-order/relate-order/state-rollback`,
    method: "get",
    params,
  });
// 修改平仓单
export const putClosingOrder = (data) =>
  lms_request({
    url: "/closure-order",
    method: "put",
    data,
  });
// 校验平仓单
export const postCheck = (data) =>
  lms_request({
    url: `/closure-order/check`,
    method: "post",
    data,
  });
// 挂起
export const postPendingDialog = (id) =>
  lms_request({
    url: `/closure-order/pending/${id}`,
    method: "post",
  });
// 保存包装信息
export const savePackingInfo = (data) =>
  lms_request({
    url: `/closure-order/packing-info`,
    method: "put",
    data,
  });
// 校验调配库存能否编辑
export const checkAdjustInventory = (id:string , piId:string, deliveryNoteId:string, packingListIds:string[]) =>
    lms_request({
        url: `/closure-order/${id}/adjust-inventory/check`,
        method: "get",
        params:{
            piId:piId,
            deliveryNoteId:deliveryNoteId,
            packingListIds:packingListIds.join(",")
        }
    });

// 获取调配库存列表
export const getMixInventory = (id, params) =>
  lms_request({
    url: `/closure-order/${id}/mix-inventory`,
    method: "get",
    params,
  });

// 删除调配库存列表
export const deleteMixInventory = (id, data) =>
  lms_request({
    url: `/closure-order/${id}/pi`,
    method: "delete",
    data,
  });

// 取消指定库存
export const resetPackingToInventory = (id, piInfoId, remark, packingIds) =>
    lms_request({
        url: `/closure-order/${id}/adjust-inventory`,
        method: "PUT",
        data:{
            piInfoId:piInfoId,
            remark:remark,
            packingIds:packingIds
        }
    });

// PI订单GET请求
export const getPiInfoModel = (id, params) =>
  omsRequest({
    url: `/proforma-invoices/${id}/query-detail`,
    method: "get",
    params,
  });

// 根据平仓单id查询对应的piId
export const getPiIdByCl = (id:string) =>
    lms_request({
        url: `/closure-order/${id}/pi`,
        method: "get",
    });

// 添加PI订单
export const postPiInfo = (data) =>
  lms_request({
    url: `/closure-order/pi-info`,
    method: "post",
    data,
  });
// 客人在库
export const getCustomerInInventory = (params) =>
  request({
    url: `/customer-in-inventory`,
    method: "get",
    params,
  });
// 获取指定库存
export const getCustomsPacking = (id, params) =>
  lms_request({
    url: `/closure-order/${id}/mix-inventory/customs-packing`,
    method: "get",
    params,
  });
// 确定指定库存
export const customsPackingSet = (id, data) =>
  lms_request({
    url: `/closure-order/${id}/customs-packing-set`,
    method: "post",
    data,
  });

// 获取已分配库存
export const searchRelatedInventoryPacking = (id, params) =>
    lms_request({
        url: `/closure-order/${id}/related-inventory-packing`,
        method: "get",
        params,
    });

// 获取已分配库存
export const removeRelatedInventoryPacking = (id, data) =>
    lms_request({
        url: `/closure-order/${id}/customs-packing-set`,
        method: "PUT",
        data,
    });

// 调配库存-平仓校验
export const postCheckMixInventory = (id) =>
  lms_request({
    url: `/closure-order/${id}/check-mix-inventory`,
    method: "post",
  });
// 出库计划&&状态回退 返回是否有选择框
export const chooseCanCancel = (id) =>
  lms_request({
    url: `/hengan-loading-plans/${id}/choose-can_cancel`,
    method: "get",
  });

// 出库计划&&状态回退 更改选项
export const putChooseCanCancel = (id) =>
  lms_request({
    url: `/hengan-loading-plans/${id}/choose-can_cancel`,
    method: "put",
  });

// 客人在库变更历史
export const getChangeHistory = (id) =>
  request({
    url: `/customer-in-inventory/${id}/history`,
    method: "get",
  });

// 审核判断出库计划
export const getDeliveryPlan = (id) =>
  lms_request({
    url: `/hengan-loading-plans/${id}/choose-can-cancel`,
    method: "get",
  });
//判断是否取消出库
export const checkCancelOutbound = (id, params) =>
  lms_request({
    url: `/hengan-loading-plans/${id}/choose-can-cancel`,
    method: "put",
    params,
  });
// /closure-order/allow-type
// 返回当前用户能创建的平仓单类型
export const getAllowType = () =>
  lms_request({
    url: `/closure-order/allow-type`,
    method: "get",
  });
//  /closure-order/{id}/pi-infos/{piInfoId}
export const getAllInventory = (id, piInfoId) =>
  lms_request({
    url: `/closure-order/${id}/pi-infos/${piInfoId}`,
    method: "get",
  });

  // 设置执行时间
  export const postExecuteTime = (data) =>
    lms_request({
      url: `/closure-order/execute-time`,
      method: "post",
      data
    });